module.exports = __webpack_public_path__ + "static/media/Misc icon_ .337308e7.jpg";